import React from "react";
import { Button } from "antd";
import { logout } from "../../slices/authSlice";
import { useAppDispatch } from '../../store';

const LogoutButton = () => {
  const dispatch = useAppDispatch();
  return (
    <Button
      onClick={() => dispatch(logout())}
      type="primary"
      className="btn-margin"
    >
      Log Out
    </Button>
  );
};

export default LogoutButton;